import l from "react";
import b from "@mui/material/Tabs";
import { styled as i } from "@mui/material/styles";
import c from "@mui/material/Tab";
const d = i(c, {
  name: "TabItem",
  slot: "root"
})({}), s = (o) => {
  const { fullLabel: r, tabContent: n, id: t, ...e } = o, a = { fullLabel: r };
  return /* @__PURE__ */ l.createElement(
    d,
    {
      "data-testid": `tab-${t}`,
      "aria-controls": `tabpanel-${t}`,
      id: `tab-${t}`,
      ...e,
      ownerState: a
    }
  );
}, m = i(b, {
  name: "TabBar",
  slot: "root"
})({});
function u(o) {
  const { children: r, value: n, id: t, tabValue: e, ...a } = o;
  return /* @__PURE__ */ l.createElement(
    "div",
    {
      role: "tabpanel",
      hidden: n !== e,
      id: `tabpanel-${t}`,
      "aria-labelledby": `tab-${t}`,
      ...a
    },
    n === e && r
  );
}
const v = ({
  id: o,
  onChange: r,
  tabItems: n,
  value: t,
  ...e
}) => /* @__PURE__ */ l.createElement(l.Fragment, null, /* @__PURE__ */ l.createElement(
  m,
  {
    value: t,
    "aria-label": e["aria-label"],
    allowScrollButtonsMobile: !0,
    scrollButtons: "auto",
    variant: "scrollable",
    "data-testid": e["data-testid"],
    id: o,
    onChange: r,
    ...e
  },
  n.map((a) => /* @__PURE__ */ l.createElement(s, { key: a.value, ...a }))
), n.map((a) => /* @__PURE__ */ l.createElement(
  u,
  {
    key: a.value,
    value: t,
    tabValue: a.value,
    id: a.id
  },
  a.tabContent
)));
export {
  v as O
};
